import { render, staticRenderFns } from "./BottomContactInput.vue?vue&type=template&id=059581ff&"
import script from "./BottomContactInput.vue?vue&type=script&lang=js&"
export * from "./BottomContactInput.vue?vue&type=script&lang=js&"
import style0 from "./BottomContactInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports